import { IEventRequestParams } from './shared.dto';

abstract class ICustomCssDAO {
    public abstract getEventCustomCss(params: IEventRequestParams): Promise<ICustomCssDTO>;
    public abstract updateEventCustomCss(params: IEventRequestParams & ICustomCssDTO): Promise<ICustomCssDTO>;
}

interface ICustomCssDTO {
    customCss: string;
}

export { ICustomCssDAO, ICustomCssDTO };
